import React from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEditViewPurchasePaymentOut from "../../../components/purchase-section/purchase-payment-out/create-edit-view-payment-out";

const AddPurchasePaymentOut = () => {
  return (
    <>
      <InnerLayout backBtn={true} title="Add Payment Out">
        <CreateEditViewPurchasePaymentOut disabled={false} page="add" />
      </InnerLayout>
    </>
  );
};
export default AddPurchasePaymentOut;
